import { useLang } from "../App";
import Reveal, { Overline } from "./Reveal";

export default function Intro() {
  const { t } = useLang();
  return (
    <section data-testid="intro-section" className="bg-ivory px-6 py-28 md:px-12 md:py-40 lg:px-20">
      <div className="max-w-4xl">
        <Reveal>
          <Overline>{t.intro.label}</Overline>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-10 font-serif text-4xl font-medium leading-[1.15] text-ink sm:text-5xl lg:text-6xl">
            {t.intro.headline}
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-10 max-w-2xl text-base font-light leading-relaxed text-ink/65 md:text-lg">
            {t.intro.text}
          </p>
        </Reveal>
      </div>
    </section>
  );
}
